// WATER FLOW RATE LIST
export const GET_WATER_FLOW_RATE_LISTS = '/water_flow_rate_list/query';
export const GET_WATER_FLOW_RATE_LIST = '/water_flow_rate_list/';
export const POST_WATER_FLOW_RATE_LIST = '/water_flow_rate_list/';
export const PUT_WATER_FLOW_RATE_LIST = '/water_flow_rate_list/';
export const DELETE_WATER_FLOW_RATE_LIST = '/water_flow_rate_list/';
